import { useApp } from "@next-platform/client-common-core";
import { Spacer } from "@nextui-org/react";
import { useEffect } from "react";

import { Text } from "@/components/customComponents";
import { LocalizedLink } from "@/components/LocalizedLink/LocalizedLink";
import Trans from "@/components/Trans/Trans";
import { TEN_SECONDS } from "@/constants";
import { useLocalizedPathname } from "@/hooks/useLocalizedPathname";

const boldComponent = { b: <b /> };

const WelcomeSubscribeStar = () => {
  const localizePath = useLocalizedPathname();
  const { applicationName } = useApp();
  const descriptionValues = { appName: applicationName };

  useEffect(() => {
    const timeout = setTimeout(() => {
      window.location.href = localizePath("/link/subscribestar");
    }, TEN_SECONDS);
    return () => {
      clearTimeout(timeout);
    };
  }, [localizePath]);

  return (
    <div>
      <Text h1>
        <Trans i18nKey="subscription:subscribeStar.welcome.title" />
      </Text>
      <Spacer y={5} />
      <Text>
        <Trans i18nKey="subscription:subscribeStar.welcome.description" components={boldComponent} values={descriptionValues} />
      </Text>
      <Spacer y={5} />
      <Text>
        <LocalizedLink className="text-link" to="/link/subscribestar" aria-label="link-subscribestar">
          <Trans i18nKey="subscription:subscribeStar.welcome.linkText" />
        </LocalizedLink>
        .
      </Text>
    </div>
  );
};

export default WelcomeSubscribeStar;
